import React, { useState } from "react";
import TextField from "@mui/material/TextField";
import InputAdornment from "@mui/material/InputAdornment";
import { withTranslation } from "react-i18next";


const CostModule = (props) => {
  return (
    <div>
      <div className="changeRequest_schedule">
        <h6 className="mb-0">{props.t("Current Cost")}</h6>
        <p className="mb-0 mt-1">SAR {parseFloat(props.projectCost?.old).toFixed(2)}</p>
      </div>
      <div className="changeRequest_schedule mt-3">
        <h6 className="mb-0">{props.t('Requested Cost')}</h6>
        <div className="row">
          <div className="col-md-12 changeRequest_datePicker mt-2">
            {/* <TextField
              fullWidth
              id="outlined-multiline-static"
              label={props.t("Specify the change")}
              type="number"
              readOnly={true}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">SAR</InputAdornment>
                ),
              }}
              name="projectCost"
              value={props.projectCost?.new}
              required
            /> */}
            <TextField
                minimumValue="0"
                id="project-cost"
                variant="outlined"
                // label='Deliverable Cost'
                decimalPlaces={2}
                value={props.projectCost?.new}
                readOnly={true}
                // size="small"
                currencySymbol={props.t("SAR")}
                fullWidth
                placeholder={props.t("Specify the change")}
                required
              />
          </div>
        </div>
      </div>
    </div>
  );
};

export default withTranslation() (CostModule);
